import { useQuery } from '@tanstack/react-query'
import { api } from './api'
import { User } from './users.service'

export interface Users {
  user: User | string
  role: 'all-access' | 'visualizer' | 'editor'
  createdAt: Date
}

export type Group = {
  _id: string
  name: string
  role?: 'all-access' | 'visualizer' | 'editor'
  users: Users[]
  active?: boolean
  createdAt?: string
}

type Groups = {
  data: Group[]
  page: number
  petPage: number
  totalPages: number
  total: number
}

async function fetchGroup(
  page?: number,
  perPage?: number,
  search?: string,
  sort?: string,
): Promise<Groups> {
  let sortName: any = 'createdAt'
  let order: string = 'desc'

  if (sort) {
    var keyNames = Object.keys(sort)
    sortName = keyNames[0]
    order = sort[sortName]
  }

  const res = await api.get('/groups', {
    params: {
      page,
      sort: sortName,
      order: order === 'desc' ? -1 : 1,
      perPage,
      search,
    },
  })
  return res.data
}

function useGroups(
  page: number | undefined,
  perPage: number | undefined,
  search: string | undefined,
  sort: string | undefined,
) {
  return useQuery(
    ['groups', page, perPage, search, sort],
    () => fetchGroup(page, perPage, search, sort),
    {
      keepPreviousData: true,
      staleTime: 5000,
    },
  )
}

export default useGroups
